(function () {
    'use strict';
    angular
        .module('app')
        .directive('browseFolderBox', browseFolderBox);
    browseFolderBox.$inject = ['$window', '$rootScope', '$scope', '$timeout', 'ngClipboard', '$mdDialog'];
    function browseFolderBox($window, $rootScope, scope, $timeout, ngClipboard, $mdDialog) {
        var directive = {
            link: link,
            restrict: 'EA',
            //scope: {
            //    msgBoxShown: '=?'
            //},
            //controller: 'browseFolderBox',
            templateUrl: 'app/msgBox/browseFolderBox.html'
        };
        return directive;
        function link(scope, element, attrs) {
        }
    }
})();